import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useAppDispatch } from '@/store';
import { GRAPHIC_TYPES_VALUES } from '@/constants/customization.constants';
import { AppState } from '@/store';
import {
  filtersRemove,
  updateColorSelectionHistory,
  updateGraphicTypesSelectionHistory,
} from '../redux/partner.actions';
import FilterTag from '@components/tailwind/FilterTag';
import SelectedFiltersImpl from '@components/tailwind/SelectedFilters';

const SelectedFilters = () => {
  const dispatch = useAppDispatch();

  const {
    filterOptions: { colors, sizes, graphicTypes, category, types },
    refData: { categories: refCategories, colors: refColors, sizes: refSizes, types: refTypes },
  } = useSelector((state: AppState) => state.partner);

  const filterRemoveHandler = (key, val) => () => {
    dispatch(filtersRemove(key, val));

    switch (key) {
      case 'colors':
        dispatch(updateColorSelectionHistory(val, true));
        break;

      case 'graphicTypes':
        dispatch(updateGraphicTypesSelectionHistory(val, true));
        break;

      default:
        break;
    }
  };

  return (
    <SelectedFiltersImpl
      {...{
        category: refCategories.find((i) => i.id === category),
        types: types.map((typeId) => refTypes.find((i) => i.id === typeId)),
        sizes: sizes.map((sizeId) => refSizes.find((i) => i.id === sizeId)),
        colors: colors.map((colorId) => refColors.find((i) => i.id === colorId)),
        graphicTypes,
        onRemove: filterRemoveHandler,
      }}
    />
  );
};

export default SelectedFilters;
